import React from 'react';
import _s from './svg.less';

const SVGView = ({ planSVG, planId }) => {
  if (!planId) return <></>;

  return (
    <div className={_s.svgView}>
      <object
        type="image/svg+xml"
        data={`https://3d.homewip.com/svg/${planId}/`}
        title="plan"
        aria-label="plan"
      />
    </div>
  );
};

export default SVGView;
